module.exports = __webpack_public_path__ + "static/media/Soccer.c4517ceb.png";